import { render, staticRenderFns } from "./VisitorUsersAge.vue?vue&type=template&id=4aebf632&"
import script from "./VisitorUsersAge.vue?vue&type=script&lang=js&"
export * from "./VisitorUsersAge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports